import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { IPrintStation } from '../../interfaces/IPrintStation';

const apiUrl = Globals.apiPath + '/printStations';

export default class PrintStationsService {
  static async getAll(restaurantId: number): Promise<IPrintStation[]> {
    const res = await axios.get<IPrintStation[]>(`${apiUrl}/${restaurantId}`);
    return res.data;
  }

  static async create(
    restaurantId: number,
    name: string
  ): Promise<IPrintStation> {
    const res = await axios.post<IPrintStation>(apiUrl, {
      restaurantId,
      name,
    });
    return res.data;
  }

  static async rename(
    restaurantId: number,
    stationId: number,
    name: string
  ): Promise<IPrintStation> {
    const res = await axios.put<IPrintStation>(
      `${apiUrl}/${restaurantId}/${stationId}`,
      { name }
    );
    return res.data;
  }

  static async delete(
    restaurantId: number,
    stationId: number
  ): Promise<IPrintStation> {
    const res = await axios.delete<IPrintStation>(
      `${apiUrl}/${restaurantId}/${stationId}`
    );
    return res.data;
  }
}
